/* HAK - grilla: titulo a 2 lineas (line-clamp) + altura reservada para tarjetas parejas. El area de imagen ya tiene alto fijo por aspect-ratio del tema. */
(function(){
  var css = '.product-item__title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;line-height:1.3;min-height:2.6em;margin-bottom:4px}'
          + '.product-item--vertical .product-item__info-inner{display:flex;flex-direction:column}'
          /* HAK 18-08-2026: sufijo "+ IVA" junto a los precios. La tienda vende neto
             (shop.taxes_included = false), asi que el sufijo va en card, ficha,
             mini-carrito y carrito con el mismo estilo. */
          + '.hak-mas-iva{font-size:0.75em;font-weight:400;white-space:nowrap;opacity:0.75;margin-left:6px;align-self:center}'
          + '.hak-iva-suffix{font-size:0.75em;font-weight:400;white-space:nowrap;opacity:0.75;margin-left:0.25em}';
  var s = document.createElement('style');
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);
})();

document.addEventListener('bcpR4q:openForm', () => {
    const ctor = customElements.get('bcp-r4q-line-item');
  if (!ctor?.elementStyles?.length) return;
  const sheet = ctor.elementStyles.at(-1).styleSheet;
  if (!sheet || sheet.__imgPatched) return;
  sheet.insertRule(
    '.variant-image { width: 140px !important; height: auto !important; }',
    sheet.cssRules.length
  );
  sheet.__imgPatched = true;
})

document.addEventListener("bcpR4q:openForm", () => {
        const root = document
                .querySelector("bcp-r4q-form-wrapper")?.shadowRoot
                ?.querySelector("bcp-r4q-form-main")?.shadowRoot;
        if (!root || root.getElementById("bss-custom-form-css")) return;

        const style = document.createElement("style");
        style.id = "bss-custom-form-css";
        style.textContent = `
                .bcp-r4q-form-main .modal-content {
                        grid-template-columns: 2fr 1fr;
                }

                @container layout (max-width: 1000px) {
                        .bcp-r4q-form-main .modal-content {
                                grid-template-columns: 1fr;
                                overflow: auto;
                        }
                        .bcp-r4q-form-main .modal-content .modal-column {
                                max-height: none;
                                overflow-y: visible;
                        }
                        .bcp-r4q-form-main .modal-content .modal-column .modal-column-content {
                                overflow-y: visible;
                        }
                }

                @container layout (max-width: 680px) {
                        .bcp-r4q-form-main .product-list bcp-r4q-line-item {
                                max-width: 480px;
                                margin-inline: auto;
                        }
                }
        `;
        root.appendChild(style);
  });
;